var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSaveS01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 3V6.4C7.5 6.96005 7.5 7.24008 7.60899 7.45399C7.70487 7.64215 7.85785 7.79513 8.04601 7.89101C8.25992 8 8.53995 8 9.1 8H15.9C16.4601 8 16.7401 8 16.954 7.89101C17.1422 7.79513 17.2951 7.64215 17.391 7.45399C17.5 7.24008 17.5 6.96005 17.5 6.4V4M17.5 21V14.6C17.5 14.0399 17.5 13.7599 17.391 13.546C17.2951 13.3578 17.1422 13.2049 16.954 13.109C16.7401 13 16.4601 13 15.9 13H9.1C8.53995 13 8.25992 13 8.04601 13.109C7.85785 13.2049 7.70487 13.3578 7.60899 13.546C7.5 13.7599 7.5 14.0399 7.5 14.6V21M21.5 9.32548V16.2C21.5 17.8802 21.5 18.7202 21.173 19.362C20.8854 19.9265 20.4265 20.3854 19.862 20.673C19.2202 21 18.3802 21 16.7 21H8.3C6.61984 21 5.77976 21 5.13803 20.673C4.57354 20.3854 4.1146 19.9265 3.82698 19.362C3.5 18.7202 3.5 17.8802 3.5 16.2V7.8C3.5 6.11984 3.5 5.27976 3.82698 4.63803C4.1146 4.07354 4.57354 3.6146 5.13803 3.32698C5.77976 3 6.61984 3 8.3 3H15.1745C15.6637 3 15.9083 3 16.1385 3.05526C16.3425 3.10425 16.5376 3.18506 16.7166 3.29472C16.9184 3.4184 17.0914 3.59135 17.4373 3.93726L20.5627 7.06274C20.9086 7.40865 21.0816 7.5816 21.2053 7.78343C21.3149 7.96237 21.3957 8.15746 21.4447 8.36154C21.5 8.59171 21.5 8.8363 21.5 9.32548Z",
    stroke: "#4C60E5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveS01);
export default __webpack_public_path__ + "static/media/save-s01.733cefb748c108b85e8c185e8d18f741.svg";
export { ForwardRef as ReactComponent };